import { render, staticRenderFns } from "./manage-alert-member-must-label.vue?vue&type=template&id=f0099286&scoped=true"
import script from "./manage-alert-member-must-label.vue?vue&type=script&lang=js"
export * from "./manage-alert-member-must-label.vue?vue&type=script&lang=js"
import style0 from "./manage-alert-member-must-label.vue?vue&type=style&index=0&id=f0099286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0099286",
  null
  
)

export default component.exports